import UserResultsPage from './UserResultsPage'
import { userResultMenu } from './sideBarOption'

export { userResultMenu }
export default UserResultsPage
